import { lazy } from "react";
import Loadable from "app/components/Loadable";

const ManageServersList = Loadable(lazy(() => import("./ManageServersList")));
const ManageServersEdit = Loadable(lazy(() => import("./ManageServersAdd")));

const ManageServersRoutes = [
  { path: "/servers/manage-servers", element: <ManageServersList /> },
  { path: "/servers/manage-servers/:mode/:id", element: <ManageServersEdit /> },
];

export default ManageServersRoutes;
